import { render, staticRenderFns } from "./checkQuestionnaires.vue?vue&type=template&id=63afbf45&scoped=true&"
import script from "./checkQuestionnaires.vue?vue&type=script&lang=js&"
export * from "./checkQuestionnaires.vue?vue&type=script&lang=js&"
import style0 from "./checkQuestionnaires.vue?vue&type=style&index=0&id=63afbf45&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63afbf45",
  null
  
)

export default component.exports